var map = {
	"./de/btn-view.png": "IS3T",
	"./en/btn-view.png": "KrOM",
	"./es/btn-view.png": "wvUF",
	"./fr/btn-view.png": "vLgy",
	"./ja/btn-view.png": "dMkQ",
	"./ko/btn-view.png": "pBz1",
	"./pt/btn-view.png": "r123",
	"./ru/btn-view.png": "EkU9",
	"./tc/btn-view.png": "Juu7",
	"./th/btn-view.png": "xQgu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yzHR";